import React from 'react'
import GitHubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import EmailIcon from '@material-ui/icons/Email';
import './Connect.css'

function Connect() {
    return (

        <div>
            <h2 className="title">Connect with me !</h2> 
        <div className="icons">
            <a href="https://github.com/sarang721"><GitHubIcon className="ico" ></GitHubIcon></a>
           
            <a href="https://www.linkedin.com/in/sarang-rajurkar-76234a192/"><LinkedInIcon className="ico"></LinkedInIcon></a>
            <a href=""><EmailIcon className="ico"></EmailIcon></a>
            
        </div>

        </div>
    )
}

export default Connect
